<template>
  <app-treeview-item class="section-item text-truncate" :selected="selected">
    <app-material-icon
      :name="icon"
      class="no-shrink"
    />

    <AppTooltip :open-delay="500" :disabled="!hasTooltip">
      <template #activator="{ props }">
        <div v-bind="props"
             ref="sectionName"
             class="text-truncate"
        >
          <span class="text--regular text-text-secondary">
            {{ sectionName }}
          </span>
        </div>
      </template>
      {{ sectionName }}
    </AppTooltip>
  </app-treeview-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppTooltip from '@/common/AppTooltip.vue'

export default defineComponent({
  name: 'DocumentsSidebarSectionItem',
  components: { AppTooltip },
  props: {
    icon: {
      type: String,
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      hasTooltip: false,
    }
  },
  async mounted () {
    await this.$nextTick()
    const sectionNameDivElement = (this.$refs['sectionName'] as HTMLDivElement)
    this.hasTooltip = sectionNameDivElement?.offsetWidth < sectionNameDivElement?.scrollWidth
  },
})
</script>

<style lang="scss" scoped>
.section-item {
  display: flex;
  align-items: flex-end;
  column-gap: 8px;
  cursor: pointer;
}
</style>
